import React from 'react';
import PropTypes from 'prop-types';

import { Pill } from './styles';
import texts from './texts.json';

const ThreadIndicator = ({ replyCount, onClick }) => {
  if (!replyCount) {
    return null;
  }

  return (
    <Pill type="button" onClick={onClick}>
      {`${replyCount} ${replyCount === 1 ? texts.reply : texts.replies} ›`}
    </Pill>
  );
};

ThreadIndicator.propTypes = {
  replyCount: PropTypes.number,
  onClick: PropTypes.func.isRequired,
};

ThreadIndicator.defaultProps = {
  replyCount: 0,
};

export default ThreadIndicator;
